import React, { useState, useEffect /*useMemo*/ } from 'react';
import { connect } from 'react-redux';
import { AppState } from '$/store';
import * as Bixby from '$/core';
import { Link } from 'react-router-dom';
import CompanyDocumentsUpload from '$/components/company-documents-upload';
import './index.scss';
import { /*DocumentsAdminService,*/ DocumentsClientService } from '$/services';

interface IProps {
  currentCompany?: Bixby.Models.AdminCompany;
}

const AdminCompanyDocumentHostingUpload: React.FC<IProps> = props => {
  const { currentCompany } = props;
  //const [documents, setDocuments] = useState<Bixby.Models.CompanyDocument[]>();
  const [companyDocumentCategories, setCompanyDocumentCategories] = useState<Bixby.Models.CompanyDocumentCategory[]>();
  const [hasError, setHasError] = useState<boolean>(false);

  useEffect(() => {
    const getCompanyDocumentCategories = async () => {
      try {
        const companyDocumentCategories: Bixby.Models.CompanyDocumentCategory[] =
          await DocumentsClientService.getDocumentCategories();
        setCompanyDocumentCategories(companyDocumentCategories);
      } catch (err: any) {
        setHasError(true);
      }
    };

    getCompanyDocumentCategories();
  }, []);

  // to be uncommented post inital doc upload phase
  // useEffect(() => {
  //   const getDocuments = async () => {
  //     if (!currentCompany) return;
  //     try {
  //       const documents: Bixby.Models.CompanyDocument[] = await DocumentsAdminService.getDocumentsByCompanyId(
  //         currentCompany.id
  //       );
  //       setDocuments(documents);
  //     } catch (err: any) {
  //       setHasError(true);
  //     }
  //   };
  //   getDocuments();
  // }, [currentCompany]);

  // const hasDocumentsWithTags = useMemo<boolean | undefined>(() => {
  //   if (!documents) return undefined;
  //   const docsWithTags = documents.filter(
  //     _ => _.companyDocumentCompanyDocumentCategories !== null && _.companyDocumentCompanyDocumentCategories.length > 0
  //   );
  //   return docsWithTags && docsWithTags.length > 1;
  // }, [documents]);

  return (
    <>
      <section className="admin-profile-section bottom">
        {hasError && <p className="error">Unable to load data in order to upload company documents.</p>}
        {!hasError && (
          <>
            <h3>Bixby Document Hosting Upload</h3>
            {currentCompany && (
              <Link className="link" to={`/admin/company/${currentCompany.id}/document-hosting`}>
                Back to Documents List
              </Link>
            )}
            <CompanyDocumentsUpload
              companyDocumentCategories={companyDocumentCategories || []}
              // hasTags={hasDocumentsWithTags}
            />
          </>
        )}
      </section>
    </>
  );
};

const mapStateToProps = (state: AppState) => {
  return {
    currentCompany: state.companyState.currentCompany,
  };
};

export default connect(mapStateToProps)(AdminCompanyDocumentHostingUpload);
